import React from 'react'
import ListCandidateView from './components/view/list-candidate-view'

const Candidate = () => {
    return (
        <div>
            <div
                className={'container'}
                style={{
                    zIndex: 10,
                    minHeight: '100vh',
                    padding: '35px',
                }}
            >
                <ListCandidateView />
            </div>
        </div>
    )
}

export default Candidate
